import {
  BatchOrderAcceptListConditionListItem,
  BatchOrderAcceptListConditionListItemFromJSON
} from '@/api/models/batch/BatchOrderAcceptListConditionListItem'

export interface BatchOrderAcceptListPageLoadResult {
  items: BatchOrderAcceptListConditionListItem
}

export function BatchOrderAcceptListPageLoadResultFromJSON(
  json: any
): BatchOrderAcceptListPageLoadResult {
  return {
    items: BatchOrderAcceptListConditionListItemFromJSON(json)
  }
}
